<div class="card col-12">


    <form [formGroup]="uploadArquivoForm" (ngSubmit)="onSubmit()">

        <div class="card-header">
            <h4 class="card-title">Documento (<span style="color: red;">obrigatório</span>)</h4>
        </div>
        <div class="card-body">

            <div class="form-group">
                <label class="form-label" for="contato">Selecione um documento PDF</label>
                <input type="file" formControlName="document" class="form-control" (change)="onChange($event)"
                    accept=".pdf" [ngClass]="{
                        'is-invalid':
                        uploadArquivoForm.controls.document.errors &&
                        uploadArquivoForm.get('document')?.touched,
                        }" />
                <div style="color: red;" *ngIf="uploadArquivoForm.get('document')?.invalid &&
                    uploadArquivoForm.get('document')?.touched">
                    Um documento PDF deve ser selecionado.
                </div>
            </div>
        </div>


        <div class="row mb-4 ms-2">
            <div class="col-12 d-flex">

                @if(isLoading){
                <button type="button" class="btn btn-light waves-effect">
                    <i class="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i> Trabalhando
                </button>
                }@else {

                <button type="submit" class="btn btn-info waves-effect waves-light d-flex">
                    <i class="mt-1 bx bx-cloud-upload d-block font-size-16 me-3"></i> Enviar Documento
                </button>
                }

                <!-- <button type="button" class="btn btn-danger waves-effect waves-light d-flex">
                <i class="mdi mdi-trash-can d-block font-size-16 me-3"></i> Cancelar Assinaturas
            </button> -->

            </div>
        </div>
    </form>
</div>